import camelCase from 'lodash/camelCase';
import { isFedRamp } from '@atlassian/atl-context';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { forgeProjectModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticSidebarShortcutsResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-sidebar-shortcuts/index.tsx';
import AsyncSidebarNextGen from '@atlassian/jira-navigation-apps-sidebar-next-gen/src/async.tsx';
import { Skeleton } from '@atlassian/jira-periscope/src/ui/skeleton/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { incidentExperimentTraitResource } from '@atlassian/jira-router-resources-software-incidents/src/services/index.tsx';
import { softwarePeriscopeNextGenRoute } from '@atlassian/jira-router-routes-software-periscope-routes/src/softwarePeriscopeNextGenRoute.tsx';
import { AsyncHorizontalNavJira } from '@atlassian/jira-horizontal-nav/src/async.tsx';
import { softwareProjectLayoutNoOnboarding } from '@atlassian/jira-software-project-layout/src/index.tsx';
import { notFoundPageEntrypoint } from '@atlassian/jira-router-routes-not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { rovoEntitlementResource } from '@atlassian/jira-router-resources-rovo-entitlement/src/services/index.tsx';
import { periscopeEntryPoint } from './common/periscope.tsx';

export const softwarePeriscopeNextGenRouteEntry = createEntry(
	softwarePeriscopeNextGenRoute,
	() => ({
		group: 'software',
		skeleton: Skeleton,
		layout: softwareProjectLayoutNoOnboarding,

		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarNextGen,
			horizontal: AsyncHorizontalNavJira,
			onlyShowHorizontalOnNav4: true,
		},

		resources: [
			...getNavigationResources(),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
			incidentExperimentTraitResource,
			projectContextResource,
			forgeProjectModuleResource,
			staticSidebarShortcutsResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			projectContextResource,
			rovoEntitlementResource,
		],

		entryPoint: () => {
			return isFedRamp() ? notFoundPageEntrypoint : periscopeEntryPoint;
		},

		meta: {
			reporting: {
				id: 'software-periscope',
				packageName: camelCase('software-periscope'),
				teamName: 'jolt',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-software-periscope-entries/src/softwarePeriscopeNextGenRouteEntry.tsx',
				whichExportToUse: 'softwarePeriscopeNextGenRouteEntry',
			},

			enabled: true,
		},
	}),
);
